/**
 * 알림 관리 관련 Write 작업 목차
 * 
 * - createNotification() - 알림 생성
 */

import apiClient from "@/utils/api";

/**
 * 알림 생성
 * @param {Object} alarmData - 알림 데이터
 * @returns {Promise<string>} 생성된 알림 ID
 */
export async function createNotification(alarmData) {
  try {
    const response = await apiClient.post("/api/alarm", alarmData);
    return response.data.id;
  } catch (error) {
    console.error("알림 생성 오류:", error);
    throw error;
  }
}
